import * as React from "react";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import Paper from "@mui/material/Paper";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Rating from "@mui/material/Rating";
import Details from "./Details";
import Messages from "./Messages";
import DonationProducts from "./DonationProducts";
import EventosRecolhidos from "../../../DonationView/EventosRecolhidos"
import { useData } from '../../../OnBoarding/DataContext';
import { useDispatch, useSelector } from "react-redux";
 import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

import {
  CollectionStatus,
  ComponentType,
  DonationStatus,
  EntityType,
} from "../../../../common/enum";
import CollectionProducts from "../../../../components/CollectionDonationCard/CollectionProducts";
import ConfirmDialog from "../../../../components/ConfirmDialog";
import {
  getDonorDetailById,
  updateCollection,
} from "../../../CreateCollection/slice";
import {
  getCancelCollectionDonationById,
  getMyActiveDonation,
  setMyActiveDonationsLimit,
  setMyActiveDonationsOffset,
  setMyActiveDonationsPage,
} from "../../slice";
import {
  setSnackbarMessage,
  setSnackbarOpen,
  setSnackbarSeverity,
} from "../../../AdminView/adminSlice";
import { addRating, updateDonation } from "../../../DonationView/slice";
import { useCollection } from "../ActionDate/useCollection";
import moment from "moment";
import { Badge, Typography } from "@mui/material";
import ChatPanel from "../../../MessagePanel/ChatPanel";

import { useNavigate } from "react-router-dom";
import {
  collectionGroup,
  getDocs,
  where,
  collection as firebaseCollection,
  query,
  getCountFromServer,
  setDoc,
  serverTimestamp,
  doc,
  onSnapshot,
} from "firebase/firestore";
import { db } from "../../../../firebase";
import { v4 as uuid } from "uuid";
import { useSnackbar } from "notistack";
import { Style } from "@mui/icons-material";
import { ClassNames } from "@emotion/react";

const OPEN_TYPE = {
  cancel: "CANCEL",
  evaluate: "EVALUATE",
  event : "EVENT"
};

const STATUS_PRESENT = {
  cancel: CollectionStatus.cancelled,
  collected: CollectionStatus.collected,
  expired: CollectionStatus.expired,
};

const ActionCard = ({
  component,
  actionViewTabs,
  setCollectionId,
  t,
  collection,
}) => {
  const {
    dashboardInfo: { selectedDonation, cancelCollectionDonation , entityProfileSelect},
    collection: { donorDetail },
    auth,
  } = useSelector((state) => state);
  const navigate = useNavigate();
  const { setMonthStartDate, setMonthEndDate, setKey } = useCollection();
  const dispatch = useDispatch();
  const { entity } = auth.profile || {};
  const { userId, entityId } = auth.user || "";
  const { enqueueSnackbar } = useSnackbar();
  const [value, setValue] = React.useState("1");
  const [ratingValue, setRatingValue] = React.useState(0);
  const [open, setOpen] = React.useState(false);
  const [motive, setMotive] = React.useState("");
  const [motiveError, setMotiveError] = React.useState(false);
  const [ratingError, setRatingError] = React.useState(false);
  const [openType, setOpenType] = React.useState("");
  const [chatOpen, setChatOpen] = React.useState(false);
  const [MessageUserCount , setMessageUserCount]  = React.useState(0);
  const rate = React.useRef();
  rate.current = ratingValue;
  const { setSharedData } = useData();
  const { sharedData } = useData();

  const toggleChatDrawer = React.useCallback((value) => {
    setChatOpen(value);
  }, []);

  const handleClose = React.useCallback(() => {
    setOpen(false);
    setRatingValue(0);
    setMotive("");
    setMotiveError(false);
    setRatingError(false);
  }, []);

  const handleChange = (event, newValue) => {
    if (newValue === "3") {
      setChatOpen(true);
    } else {
      setValue(newValue);
    }
  };

  const cancelHandle = React.useCallback(() => {
    setOpen(true);
    setOpenType(OPEN_TYPE.cancel);
  }, []);

  const evaluateHandle = React.useCallback(() => {
    setOpen(true);
    setOpenType(OPEN_TYPE.evaluate);
  }, []);

  const evaluateEvent = React.useCallback(() => {
    var donationIDEventos = collection?.collection?.donationId;
    var collectionEventos = collection
    setSharedData({
      donationIDEventos,
      collectionEventos
    });
    navigate("/eventos-recolhidos");
  }, [collection]);

  const saveNotificationForCancelCollection = React.useCallback(async () => {
    const notificationUid = uuid();
    try {
      await setDoc(doc(db, "notifications", notificationUid), {
        collection: collection,
        donorDetail: donorDetail,
        donorUserId: donorDetail?.userId,
        donation: cancelCollectionDonation,
        cancelledUserId: userId,
        cancelMotive: motive,
        collectorDetail: auth?.profile,
        isRead: false,
        notificationUid,
        updatedDate: serverTimestamp(),
      });
      const notificationUid2 = uuid();
      await setDoc(doc(db, "notifications", notificationUid2), {
        collection: collection,
        donorDetail: collection?.recetorEntity,
        donorUserId: collection?.recetorEntity?.entityId,
        donation: cancelCollectionDonation,
        cancelledUserId: collection?.recetorEntity?.entityId,
        cancelMotive: motive,
        collectorDetail: collection?.recetorEntity,
        isRead: false,
        notificationUid2,
        updatedDate: serverTimestamp(),
      });
    } catch (err) {}
  }, [motive, collection]);

  const rateCollectionDonation = React.useCallback(() => {
    const payload = {
      donationId: collection?.collection.donationId,
      collectionId: collection?.collection.id,
      createdBy: userId,
      rating: ratingValue,
      feedback: motive,
    };
    dispatch(addRating(payload))
      .unwrap()
      .then((res) => {
        const currentDate = new Date();
        const firstDate = new Date(
          currentDate.getFullYear(),
          currentDate.getMonth(),
          1
        );
        const lastDate = new Date(
          currentDate.getFullYear(),
          currentDate.getMonth() + 1,
          0
        );
        setMonthStartDate(moment(firstDate).format("YYYY-MM-DD"));
        setMonthEndDate(moment(lastDate).format("YYYY-MM-DD"));
        setKey(Math.random());
        enqueueSnackbar({
          message: t("collectionFeedbackSuccessfully"),
          variant: "success",
        });
        setOpen(false);
        setRatingValue(0);
        setMotive("");
      })
      .catch(() => {
        enqueueSnackbar({
          message: t("someThingWentWrong"),
          variant: "error",
        });
      });
  }, [dispatch, ratingValue, motive, setMonthStartDate, setMonthEndDate]);

  const updatingCollection = React.useCallback(
    async (status) => {
      let payload = {};
      payload["collectionId"] = collection?.collection.id;
      payload["addressId"] = collection?.collection.collectionAddressId;
      payload["status"] = status;
      //payload["motive"] = status === CollectionStatus.cancelled ? motive : "";
      payload["motive"] =  motive ? motive : "";
      payload["dateOfCollection"] = collection?.collection.dateOfCollection;
      payload["updatedBy"] = userId;
      payload["entityType"] = entityProfileSelect ? entityProfileSelect : entity.entityType
      await dispatch(updateCollection(payload))
        .unwrap()
        .then(async (res) => {
          if (status === CollectionStatus.collected) {
            rateCollectionDonation();
          } else {
            await saveNotificationForCancelCollection();
            const currentDate = new Date();
            const firstDate = new Date(
              currentDate.getFullYear(),
              currentDate.getMonth(),
              1
            );
            const lastDate = new Date(
              currentDate.getFullYear(),
              currentDate.getMonth() + 1,
              0
            );
            setMonthStartDate(moment(firstDate).format("YYYY-MM-DD"));
            setMonthEndDate(moment(lastDate).format("YYYY-MM-DD"));
            setKey(Math.random());
            setOpen(false);
            setMotive("");
          }
          enqueueSnackbar({
            message:
              status === CollectionStatus.cancelled
                ? 'Reserva cancelada com sucesso'
                : t("collectionCollectedSuccess"),

            variant: "success",
          });
        })
        .catch(() => {
          enqueueSnackbar({
            message: t("someThingWentWrong"),

            variant: "error",
          });
        });
    },
    [dispatch, CollectionStatus, motive, collection]
  );
  let currentTimeZone = new Intl.DateTimeFormat().resolvedOptions().timeZone;
  const cancelDonation = React.useCallback(() => {
    let payload = {};
    payload["donationId"] = selectedDonation?.donation?.donationId;
    payload["status"] = DonationStatus.cancel;
    payload["updatedBy"] = userId;
    payload["addressId"] = selectedDonation?.donation?.addressId;
    payload["isPublish"] = true;
    payload["note"] =
      motive.length > 0 ? motive : selectedDonation?.donation?.note;
    payload["availableFromDate"] =
      selectedDonation?.donation?.availableFromDate;
    payload["availableToDate"] = selectedDonation?.donation?.expiryDate;
    dispatch(updateDonation(payload))
      .unwrap()
      .then((res) => {
        const data = {
          limit: 10,
          offset: 0,
          // status: DonationStatus.new,
        };
        if (entity.entityType === EntityType.donor) {
          data["entityId"] = entity.entityId;
        }
        dispatch(getMyActiveDonation(data));
        dispatch(setMyActiveDonationsLimit(10));
        dispatch(setMyActiveDonationsOffset(0));
        dispatch(setMyActiveDonationsPage(1));
        enqueueSnackbar({
          message: t("donationCancelledSuccessfully"),

          variant: "success",
        });
        setOpen(false);
        setMotive("");
      })
      .catch(() => {
        enqueueSnackbar({
          message: t("someThingWentWrong"),

          variant: "error",
        });
      });
  }, [dispatch, selectedDonation]);

  const onConfirm = React.useCallback(async () => {
    if (openType === OPEN_TYPE.cancel) {
      if (motive.length === 0) {
        setMotiveError(true);
      } else {
        if (component === ComponentType.AGENDA) {
          await updatingCollection(CollectionStatus.cancelled);
        } else {
          cancelDonation();
        }
      }
    } else {
      if (ratingValue > 0) {
        await updatingCollection(CollectionStatus.collected);
      } else {
        setRatingError(true);
      }
    }
  }, [openType, component, motive, ratingValue]);

  React.useEffect(() => {
    if (collection?.collection?.donationId)
      dispatch(
        getCancelCollectionDonationById(collection?.collection.donationId)
      )
        .unwrap()
        .then((res) => {
          const data = {
            entityId: res.donations.donation.entityId,
          };
          dispatch(getDonorDetailById(data));
          getMessageCount(collection?.collection.id)
        });
  }, [dispatch, collection]);

  if (entity.isGroupEntity && entity.isParentEntity) {
    actionViewTabs.map((list) => {
      if (list && list.title === "Messages") {
        actionViewTabs.pop();
      }
    });
  } else {
    const activeTabs = actionViewTabs.filter((list) => {
      return list && list.title === "Messages";
    });
    if (activeTabs && activeTabs.length === 0) {
      actionViewTabs.push({
        id: "3",
        title: "Messages",
      });
    }
  }

  // const getMessageCount = async (id) => {
  //   try {
      
  //     const q =query(collectionGroup(db,"messages"))
  //     where("isRead", "==", false),
  //     // where("senderId", "!=", userId),
  //     where("recevierId", "==", userId),
  //     where("collectionId", "==", id)
  //     // const qu = query(
  //     //   collectionGroup(db, "messages"),
  //     //   // where("senderId", "==", userId),
  //     //   where("collectionId", "==", id)
  //     // );
  //     const resCount = await getCountFromServer(q);
  //     const res = await getCountFromServer(q);
  //     setMessageUserCount(res.data().count);
  //     return { unReadcount: res.data().count, count: resCount.data().count };


  //   } catch (err) {
  //     console.log("aqui --->", err.message);
  //   }
  // };

  const getMessageCount = async (id) => {
    try {
      const q = query(collectionGroup(db, "messages"),
        
        where("isRead", "==", false),
        where("collectionId", "==", id),
        where("recevierId",  "==", userId)
      );
  
      const querySnapshot = await getDocs(q);
     
      if (querySnapshot.empty) {
       // console.log("Nenhum documento encontrado para a consulta.");
        return { unReadCount: 0 };
      }

      setMessageUserCount(querySnapshot.docs.length);
  
      return { unReadCount: querySnapshot.docs.length };
    } catch (err) {
     // console.log("aqui --->", err.message);
    }
  };
  

  // const getMessageUserCount = () => {
  //   const q = query(
  //     collectionGroup(db, "messages"),
  //     where("isRead", "==", false),
  //     where("recevierId", "==", userId)
  //   );
  //   const unsub = onSnapshot(q, (querySnapshot) => {
  //     setMessageUserCount(querySnapshot.size);
  //   });
  //   return () => {
  //     unsub();
  //   };
  // };

  return (
    <React.Fragment>
      <Paper sx={{ typography: "body1" }}>
        <TabContext value={value}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              borderBottom: 1,
              borderColor: "divider",
            }}
          >
            <TabList onChange={handleChange} aria-label="action card label">
              {actionViewTabs?.map((list) => (
                <Tab
                  sx={
                    list.id === "3" && {
                      padding: "15px 20px !important",
                    }
                  }
                  label={
                    list.id === "3" ? (
                      <Badge
                        badgeContent={
                          MessageUserCount
                        }
                        sx={{
                          "& .MuiBadge-badge": {
                            backgroundColor: "#1b727e",
                            color: "#fff",
                            right: "-10px !important",
                          },
                        }}
                        max={99}
                        key={list.id}
                      >
                        {t(`${list.title}`)}
                      </Badge>
                    ) : (
                      t(`${list.title}`)
                    )
                  }
                  // {...list.id === "3" &&
                  //   component === ComponentType.AGENDA &&
                  //   (Object.values(STATUS_PRESENT).includes(
                  //     collection?.collection?.status
                  //   ) ||
                  //   (new Date(
                  //     collection?.collection?.dateOfCollection
                  //   ) >=
                  //     new Date()) )   === true
                  // ? $(".SendloadingButton").css("display" , "none")
                  // : $(".SendloadingButton").css("display" , "flex")}
                  // disabled={
                  //   list.id === "3" &&
                  //   component === ComponentType.AGENDA &&
                  //   (Object.values(STATUS_PRESENT).includes(
                  //     collection?.collection?.status
                  //   ) ||
                  //   (new Date(
                  //     collection?.collection?.dateOfCollection
                  //   ) >=
                  //     new Date()) )   === true
                  // }
                  value={list.id}
                  key={list.id}
                />
              ))}
            </TabList>
          </Box>
          {((component === ComponentType.AGENDA &&
            collection !== undefined &&
            Object.keys(collection).length > 0) ||
            (component === ComponentType.DONATION &&
              selectedDonation !== undefined &&
              Object.keys(selectedDonation).length > 0)) && (
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "right",
              }}
            >
              {((component === ComponentType.DONATION &&
                entityId === selectedDonation?.donation.entityId &&
                !Object.values(STATUS_PRESENT).includes(
                  selectedDonation?.donation.status
                )) ||
                (component === ComponentType.AGENDA &&
                  !Object.values(STATUS_PRESENT).includes(
                    collection?.collection.status
                  ))) && (
                <Button
                  color="error"
                  sx={{
                    background: "#FFEEEE",
                    color: "#FF0000",
                    my: 1,
                    "&:hover": { background: "#FF0000", color: "#FFEEEE" },
                    borderRadius: "4px",
                  }}
                  onClick={cancelHandle}
                >
                  {t("cancel")}
                </Button>
              )}
              {component === ComponentType.AGENDA &&
                !Object.values(STATUS_PRESENT).includes(
                  collection?.collection.status
                ) && (
                  collection.collectionProducts.length == 0 ? 
                  <Button
                    variant="contained"
                    sx={{ m: 1, borderRadius: "4px" }}
                    onClick={evaluateEvent}
                  >
                    {t("collected")}
                  </Button>
               :  <Button
                    variant="contained"
                    sx={{ m: 1, borderRadius: "4px" }}
                    onClick={evaluateHandle}
                  >
                  {t("collected")}
             </Button>)}
            </Box>
          )}
          <TabPanel value={actionViewTabs[0]?.id}>
            <Details
              component={component}
              collection={collection}
              donation={selectedDonation}
              t={t}
            />
          </TabPanel>
          <TabPanel value={actionViewTabs[1]?.id}>
            {component === ComponentType.AGENDA ? (
              collection !== undefined && (
                <>
                  {Object.keys(collection).length > 0 &&
                    collection?.collectionProducts.length > 0 && (
                      <Typography
                        variant="body2"
                        color={"text.secondary"}
                        fontWeight={600}
                        mb={1.5}
                        gutterBottom
                      >{`${t("agendaArticles1")} ${
                        collection?.collectionProducts.length
                      }  ${t("agendaArticles2")} `}</Typography>
                    )}
                  <CollectionProducts
                    products={collection?.collectionProducts}
                    t={t}
                    componentType={ComponentType.AGENDA_PRODUCT}
                  />
                </>
              )
            ) : (
              <DonationProducts
                collectionById={collection}
                donation={selectedDonation}
                t={t}
                componentType={ComponentType.AGENDA_PRODUCT}
              />
            )}
          </TabPanel>
          <TabPanel value={actionViewTabs[2]?.id}>
            <Messages t={t} />
          </TabPanel>
        </TabContext>
        <ConfirmDialog
          open={open}
          handleClose={handleClose}
          title={
            component === ComponentType.AGENDA
              ? openType === OPEN_TYPE.cancel
                ? 'Tem a certeza que deseja cancelar esta reserva?'//t("cancelCollectionDialogTitle")
                : openType === OPEN_TYPE.evaluate ? t("evaluateDonation") 
                : openType === OPEN_TYPE.event ? 'Avaliar doação tipo evento':
                t("cancelDontaionDialogTitle")
              : t("cancelDontaionDialogTitle")
          }
          content={
            <React.Fragment>
              <>
                {new Date(collection.collection.dateOfCollection) > new Date() && openType != OPEN_TYPE.cancel &&(
                  <Box sx={{fontSize: "12px",backgroundColor: "#E6EFFA",padding: "14px",borderRadius: "8px",marginBottom: "19px",color: "black"}}>
                  <InfoOutlinedIcon sx={{ color: "#0167D6", cursor: "pointer", marginRight: "5px" }} />
                   Esta ação está a ser efetuada antes da data e hora definidas para a recolha. Caso prossiga, certifique-se de que a informação está correta.
                  </Box>

                )}
              </>
           

              {openType === OPEN_TYPE.evaluate && (
                <>
                  <Rating
                    component="span"
                    name="simple-controlled"
                    defaultValue={ratingValue}
                    value={ratingValue}
                    onChange={(event, newValue) => {
                      setRatingValue(newValue);
                      setRatingError(false);
                    }}
                    //precision={0.1}
                  />
                  {ratingError && (
                    <Typography variant="subtitle2" color="error">
                      O campo é de preenchimento obrigatório
                    </Typography>
                  )}
                </>
              ) || openType === OPEN_TYPE.event && (
                <>
                  <Rating
                    component="span"
                    name="simple-controlled"
                    defaultValue={ratingValue}
                    value={ratingValue}
                    onChange={(event, newValue) => {
                      setRatingValue(newValue);
                      setRatingError(false);
                    }}
                    //precision={0.1}
                  />
                  <TextField
                    sx={{ width: "100%", mt: 1 }}
                    label={'Escreva a sua opinião...'}
                    multiline
                    minRows={4}
                    value={motive}
                    onChange={(e) => {
                      setMotive(e.target.value);
                      setMotiveError(false);
                    }}
                    required={openType === OPEN_TYPE.cancel ? true : false}
                    error={motiveError}
                    helperText={
                      motiveError &&
                      `O campo ${t("remarks")} é de preenchimento obrigatório`
                    }
                  />
                  {ratingError && (
                    <Typography variant="subtitle2" color="error">
                      O campo é de preenchimento obrigatório
                    </Typography>
                  )}

                  {/* <EventosRecolhidos/> */}
                </>
              )}
              {openType != OPEN_TYPE.event &&(
                <TextField
                sx={{ width: "100%", mt: 1 }}
                label= {openType === OPEN_TYPE.cancel ? 'Motivo...': 'Escreva a sua opinião...'}
                multiline
                minRows={4}
                value={motive}
                onChange={(e) => {
                  setMotive(e.target.value);
                  setMotiveError(false);
                }}
                required={openType === OPEN_TYPE.cancel ? true : false}
                error={motiveError}
                helperText={
                  motiveError &&
                  `O campo ${t("remarks")} é de preenchimento obrigatório`
                }
                />
              )}
             
            </React.Fragment>
          }
          
          onConfirm={onConfirm}
          
          cancelButtonTitle={t("cancel")}
          confirmButtonTitle={t("confirm")}

          
        />
      </Paper>
      <ChatPanel
        component={component}
        collection={collection}
        chatdrawerState={chatOpen}
        toggleChatDrawer={toggleChatDrawer}
        t={t}
      />
    </React.Fragment>
  );
};

export default ActionCard;
